import { Link } from "wouter";
import { ArrowRight, Mail } from "lucide-react";

export default function EmailMovedBanner() {
  return (
    <div className="rounded-lg border border-[#FF5C00]/30 bg-[#FF5C00]/[0.06] p-4 flex flex-col sm:flex-row sm:items-center justify-between gap-3" data-testid="banner-email-moved">
      <div className="flex items-start gap-3">
        <Mail className="w-5 h-5 text-[#FF5C00] shrink-0 mt-0.5" />
        <p className="text-sm leading-relaxed">Marketing sends are now prepared for approval in Email. Nothing here sends on its own. Templates stay editable on this page.</p>
      </div>
      <Link href="/admin/email?tab=approvals" data-testid="link-open-email" className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#C24600] dark:text-[#FF8A47] whitespace-nowrap">Open Email <ArrowRight className="w-4 h-4" /></Link>
    </div>
  );
}
